// Library Imports
import * as React from "react";
import { Grid, Stack, Link, Button, Typography } from "@mui/material";
import { useHistory } from "react-router-dom";
import CustomChip from "../CustomChip";
import { checkPrivileges } from "../../utils/PrivilegesHelper";
import { PrivilegesContext } from "../../PrivilegesContext";

interface Props {
  claimNumber: string;
  claimType: string;
  isStepTwoValid: boolean;
  handleClaimSubmit: () => void;
  claimStatus: string;
  handleDownloadFile: any;
}

const ClaimBuilderStepTwoHeader: React.FC<Props> = ({
  claimNumber,
  claimType,
  isStepTwoValid,
  handleClaimSubmit,
  claimStatus,
  handleDownloadFile,
}) => {
  const history = useHistory();
  const userPrivileges = React.useContext(PrivilegesContext);

  const handleBackToStepOne = () => {
    history.goBack();
  };

  const handleBackToClaimList = () => {
    history.go(-2);
  };

  return (
    <Grid container className="panel-container" borderRadius={"4px"}>
      <Grid item xs={12}>
        <Grid container className="panel-show-container">
          <Grid container className="panel-information-container">
            <Grid container direction="row" className="admin-header">
              <Grid item xs={12} className="box-header">
                <Stack
                  direction={"row"}
                  justifyContent={"space-between"}
                  paddingX={3}
                  paddingY={2}
                  alignItems={"center"}
                  display={"flex"}
                  spacing={0}
                >
                  <Grid item>
                    <Typography
                      className="panel-header"
                      sx={{ fontSize: "21px", fontWeight: 700 }}
                    >
                      Claim Builder - Review
                    </Typography>
                    <Typography
                      sx={{
                        color: "#707070",
                        fontSize: "16px",
                        fontWeight: 500,
                        lineHeight: "22px",
                        letterSpacing: "1px",
                      }}
                    >
                      Claim Type: {claimType || "N/A"} • Claim #{claimNumber}
                    </Typography>
                  </Grid>
                  <div style={{ display: "flex", flexDirection: "row" }}>
                    <Link
                      onClick={handleBackToStepOne}
                      className=""
                      sx={{
                        textDecoration: "underline",
                        color: "#4A4442",
                        marginTop: "10px",
                        marginRight: "20px",
                      }}
                    >
                      Back to Step One
                    </Link>
                    <Link
                      onClick={handleBackToClaimList}
                      className=""
                      sx={{
                        textDecoration: "underline",
                        color: "#4A4442",
                        marginTop: "10px",
                      }}
                    >
                      Back to Claim List
                    </Link>

                    {checkPrivileges(userPrivileges, "Download Claim CLPs") && (
                      <Button
                        onClick={handleDownloadFile}
                        className="basic-button generate-pdf orange-btn"
                        disabled={!isStepTwoValid}
                        sx={{
                          backgroundColor: isStepTwoValid
                            ? "#FF890A"
                            : "#A29D9B !important",
                          paddingX: "10px",
                          height: "40px",
                        }}
                      >
                        Download
                      </Button>
                    )}

                    <Button
                      onClick={handleClaimSubmit}
                      className="basic-button generate-pdf orange-btn"
                      disabled={
                        !isStepTwoValid ||
                        claimStatus === "submitted" ||
                        claimStatus === "pending_submission"
                      }
                      sx={{
                        backgroundColor:
                          !isStepTwoValid ||
                          claimStatus === "submitted" ||
                          claimStatus === "pending_submission"
                            ? "#A29D9B !important"
                            : "#FF890A",
                        paddingX: "10px",
                        height: "40px",
                      }}
                    >
                      Submit
                    </Button>
                  </div>
                </Stack>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ClaimBuilderStepTwoHeader;
